import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38ce4c94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "multi_videos_header_archive"
}
const _hoisted_2 = { class: "date_picker" }
const _hoisted_3 = { class: "pagination" }

import IconButton from '@/components/molecules/IconButton'
import SimplePagination from '@//components/molecules/SimplePagination'
import DateTimePicker from '@/components/molecules/DateTimePicker'
import Icon from '@/components/atoms/Icon'
import { useStore } from 'vuex'
import { computed, onMounted, ref, withDefaults } from 'vue'

type StartDateType = {
  date: Date
  time: string
}

type PropsType = {
  isLoaded?: boolean
  startDate: StartDateType | null
  totalCameras: number | null
  division: number | null
  currentPage: number | null
  fullScreen: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiVideosHeader',
  props: {
    isLoaded: { type: Boolean, default: false },
    startDate: null,
    totalCameras: { default: null },
    division: { default: null },
    currentPage: { default: null },
    fullScreen: { type: Boolean, default: false }
  },
  emits: ["update:startDate", "changeDisplayDate", "pageChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:startDate', value: StartDateType | null): void
  (e: 'changeDisplayDate'): void
  (e: 'pageChange', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoaded: boolean, startDate: StartDateType | null, totalCameras: number | null, division: number | null, currentPage: number | null, fullScreen: boolean };

const store = useStore()
const isOpen = ref<boolean>(false)
const closeTime = ref<number>(3000)
const closeTimeout = ref<ReturnType<typeof setTimeout> | null>(null)





onMounted(() => {
  closeTimeout.value = setTimeout(() => {
    toggleNav()
  }, closeTime.value)
})

const permissions = computed(() => store.getters['auth/permissions'])

const date = computed({
  get: () => props.startDate,
  set: (v) => {
    emit('update:startDate', v)
  },
})

/**
 * ナビゲーションの開閉
 */
const toggleNav = () => {
  isOpen.value = !isOpen.value
}

const clearClose = () => {
  if (closeTimeout.value) {
    clearTimeout(closeTimeout.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multi_videos_header", { open: isOpen.value, close: isOpen.value === false }]),
    onMouseenter: clearClose
  }, [
    (_unref(permissions).archive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(DateTimePicker), {
              modelValue: _unref(date),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(date) ? (date).value = $event : null)),
              type: "TimePicker",
              disabled: __props.fullScreen
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createVNode(_unref(IconButton), {
            class: "icon-button",
            icon: "keyboard_arrow_right",
            iconColor: "color-white",
            bgColor: "primary",
            useBorder: false,
            disabled: !__props.isLoaded || __props.fullScreen,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeDisplayDate')))
          }, null, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(SimplePagination), {
        currentPage: __props.currentPage,
        total: __props.totalCameras,
        pageSize: __props.division,
        disabled: !__props.isLoaded,
        onPageChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('pageChange', $event)))
      }, null, 8, ["currentPage", "total", "pageSize", "disabled"])
    ]),
    _createElementVNode("button", {
      onClick: toggleNav,
      class: "header_controller_btn"
    }, [
      _withDirectives(_createVNode(_unref(Icon), { type: "keyboard_arrow_up" }, null, 512), [
        [_vShow, isOpen.value]
      ]),
      _withDirectives(_createVNode(_unref(Icon), { type: "keyboard_arrow_down" }, null, 512), [
        [_vShow, !isOpen.value]
      ])
    ])
  ], 34))
}
}

})